/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable import/no-named-as-default */
/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/**
 * 支付宝小程序定制化首页
 */

import '../../store';
import { Component, InjectReactive, Mixins } from 'vue-property-decorator';

import HomeBottomBar from '@/components/home-bottom-bar';
import IdenttityScoreMixins from '@/mixins/finance-identity';
import isPrerendering from '@/shared/utils/isPrerendering';
import store from '@/store';
import { namespace } from 'vuex-class';
import Bootstrap from '@/shared/utils/bootstrap';
import platform from '@/shared/utils/platform';
import { RouterV2Enum } from '@/router/router-names';
import { Visit } from '@/enums/tianjiangConf';
import FinanceBusiness from '@/mixins/finance-business';
import { OcrProcessSourceEnum } from '@/shared/tools/ocr/enum';
import { agreementService } from '@/service/confirm-agreements';
import BrandGuide from '../../components/brand-guide';
import RiskStatement from '../../components/risk-statement';
import type { Home } from '../../types';
import FinanceCreditCard from '../../components/finance-credit-card';
import FutureList from '../../components/advantage-list';

// 天降红包
const RedPacket = () => import(
  /* webpackChunkName: "red-packet" */'../../components/red-packet'
) as any;

// 首页 未登录提示信息
const NoticeBar = () => import(
  /* webpackChunkName: "notice-bar" */'../../components/notice-bar'
) as any;

const _isPrerendering = isPrerendering();
const style: Dictionary = require('./index.module.scss');

const HomeStore = namespace('home');

@Component
export default class AliminiTaglessHome extends Mixins(
  IdenttityScoreMixins,
  FinanceBusiness,
) {
  @InjectReactive() homePage!: Home;

  @HomeStore.Action getCreditData!: (shouldRefresh?: boolean) => Promise<void>;

  @HomeStore.Action getAliProductStatus!: () => Promise<void>;

  private get checkUserInfoToken() {
    return platform.isAlipayMini && !store.state.base.originUserInfo.token;
  }

  private get checkUserStatus() {
    return this.creditData && this.creditData.creditStatus;
  }

  private created() {
    if (!_isPrerendering) {
      if (this.homePage && this.homePage.shouldCorrectRouteByCredit()) {
        this.homePage.correctRouteByCredit();
      } else {
        agreementService.preloadAgreementsData();
        this.updatedIdentityScore(OcrProcessSourceEnum.HOME);
      }
    }
  }

  private mounted() {
    if (_isPrerendering) {
      document.dispatchEvent(new Event('render-event'));
    }

    if (this.homePage) {
      this.homePage.hideLoading();
    }
  }

  private async onCheckUserInfo() {
    if (!store.state.base.token) {
      await Bootstrap.init(false);
      Promise.all([
        this.getCreditData(),
        agreementService.preloadAgreementsData(),
        this.updatedIdentityScore(OcrProcessSourceEnum.HOME),
      ]).then(() => {
        this.getAliProductStatus();
        if (this.checkUserStatus) {
          this.$router.replace(RouterV2Enum.qualityAliminiHome);
        }
      });
    }
  }

  private render() {
    return (
      <div class={style.aliminiHomeContainer} onClick={this.onCheckUserInfo.bind(this)}>
        <div>
        {this.checkUserInfoToken
              && <NoticeBar aliminiNotice='您还未登录，暂时无法申请' onNeedLogin={this.onCheckUserInfo.bind(this)}/>}

          <RedPacket
            visit={Visit.Tagless}
          />
          <FinanceCreditCard hasLoad={true} onEmitClick={this.onCheckUserInfo.bind(this)} />
          <FutureList />
          <BrandGuide />
          <RiskStatement />
          <div class={style.safeArea}>
            <div class={style.navBarHeight}></div>
          </div>
        </div>
        <HomeBottomBar />
      </div>
    );
  }
}
